import React, { useRef, useState } from 'react';
import { Box, Paper, Typography, BottomNavigation, BottomNavigationAction, Button } from '@mui/material';
import Barcode from 'react-barcode';
import LoyaltyIcon from '@mui/icons-material/CardMembership';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import PromoPage from './PromoPage';
import { signOut } from 'firebase/auth';
import { auth } from './services/firebase';
import * as htmlToImage from 'html-to-image';
import AcquistiPage from './AcquistiPage';
import SwipeableViews from 'react-swipeable-views';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from './services/firebase';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

export default function WelcomePage({ user }: { user: any }) {
  const [page, setPage] = useState(0);
  const [puntiTotali, setPuntiTotali] = useState<number | null>(null);
  const cardRef = useRef<HTMLDivElement>(null);

  const handleLogout = () => {
    signOut(auth);
    window.location.reload();
  };

  const handleExport = async () => {
    if (cardRef.current) {
      const dataUrl = await htmlToImage.toPng(cardRef.current);
      const link = document.createElement('a');
      link.download = 'fidelity-card.png';
      link.href = dataUrl;
      link.click();
    }
  };

  // Calcola i punti totali dal db
  React.useEffect(() => {
    const fetchPunti = async () => {
      let totale = 0;

      // Scontrini automatici
      const q1 = query(
        collection(db, 'transazioni'),
        where('cliente_id', '==', user.codiceCliente)
      );
      const snap1 = await getDocs(q1);
      snap1.forEach(doc => {
        const dati = doc.data();
        if (typeof dati.punti === 'number') totale += dati.punti;
      });

      // Movimenti manuali
      const q2 = query(
        collection(db, 'transazioni_manuali'),
        where('cliente_id', '==', user.codiceCliente)
      );
      const snap2 = await getDocs(q2);
      snap2.forEach(doc => {
        const dati = doc.data();
        if (typeof dati.punti === 'number') totale += dati.punti;
      });

      setPuntiTotali(totale);
    };

    if (user && user.codiceCliente) {
      fetchPunti();
    }
  }, [user]);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  if (!user || !user.barcode) {
    return (
      <Box sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        <Typography variant="h6" color="primary">Caricamento dati...</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        pt: 2,
        pb: 7,
      }}
    >
      <Box sx={{ flex: 1, width: '100%', maxWidth: 400, display: 'flex', alignItems: 'flex-start', justifyContent: 'center' }}>
        <SwipeableViews
          index={page}
          onChangeIndex={setPage}
          style={{ width: '100%' }}
          containerStyle={{ width: '100%' }}
          resistance
        >
          {/* Pagina Fidelity Card */}
          <div>
            <Paper
              elevation={8}
              sx={{
                p: 4,
                width: '100%',
                maxWidth: 320,
                mx: 'auto',
                borderRadius: 4,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                bgcolor: '#fff',
                mt: 4
              }}
            >
              {/* Fidelity Card esportabile */}
              <Box
                ref={cardRef}
                sx={{
                  width: '100%',
                  bgcolor: '#f5f5f5',
                  borderRadius: 3,
                  p: 3,
                  mb: 2,
                  boxShadow: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Typography variant="h6" align="center" sx={{ fontWeight: 700, color: '#2a5298', mb: 1 }}>
                  Fidelity Card
                </Typography>
                <Typography
                  variant="h5"
                  align="center"
                  sx={{
                    mb: 1,
                    fontWeight: 700,
                    letterSpacing: 1,
                    textTransform: 'uppercase',
                    color: '#2a5298'
                  }}
                >
                  {user.nome} {user.cognome}
                </Typography>
                <Barcode value={user.barcode} format="EAN13" width={2} height={80} displayValue />
              </Box>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mb: 2, fontWeight: 600 }}
                onClick={handleExport}
              >
                Salva la tua Fidelity Card
              </Button>
              <Box sx={{ width: '100%', mt: 2, mb: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Typography variant="subtitle2" color="primary" sx={{ letterSpacing: 1 }}>
                  Punti
                </Typography>
                {puntiTotali === null ? (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    Caricamento punti...
                  </Typography>
                ) : puntiTotali === 0 ? (
                  <Typography variant="h6" color="primary" sx={{ mt: 1, fontWeight: 700, textAlign: 'center' }}>
                    Inizia ad accumulare punti
                  </Typography>
                ) : (
                  <Typography variant="h2" color="primary" sx={{ mt: 1, fontWeight: 700, lineHeight: 1 }}>
                    {puntiTotali}
                  </Typography>
                )}
              </Box>
            </Paper>
          </div>
          {/* Pagina Acquisti */}
          <div>
            <Paper sx={{
              p: 4,
              width: '100%',
              maxWidth: 320,
              mx: 'auto',
              borderRadius: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              bgcolor: '#fff',
              mt: 4
            }}>
              <Typography variant="h5" align="center">Acquisti</Typography>
              <AcquistiPage codiceCliente={user.codiceCliente} />
            </Paper>
          </div>
          {/* Pagina Promo */}
          <div>
            <Paper sx={{
              p: 4,
              width: '100%',
              maxWidth: 320,
              mx: 'auto',
              borderRadius: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              bgcolor: '#fff',
              mt: 4
            }}>
              <PromoPage />
            </Paper>
          </div>
          {/* Pagina Profilo */}
          <div>
            <Paper
              sx={{
                p: 4,
                width: '100%',
                maxWidth: 320,
                mx: 'auto',
                borderRadius: 4,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                bgcolor: '#fff',
                mt: 4
              }}
            >
              <AccountCircleIcon sx={{ fontSize: 64, color: '#2a5298', mb: 2 }} />
              <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                Profilo utente
              </Typography>
              <Box sx={{ width: '100%', textAlign: 'left' }}>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <b>Nome:</b> {user.nome}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <b>Cognome:</b> {user.cognome}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <b>Data di nascita:</b>{' '}
                  {user.dataNascita
                    ? new Date(user.dataNascita).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' })
                    : ''}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <b>Cellulare:</b> {user.cellulare}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <b>Email:</b> {user.email}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <b>Codice cliente:</b> {user.codiceCliente}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <b>Punti:</b>{' '}
                  {puntiTotali === null
                    ? 'Caricamento...'
                    : puntiTotali === 0
                      ? 'Inizia ad accumulare punti'
                      : puntiTotali}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <b>Barcode:</b> {user.barcode}
                </Typography>
              </Box>
              <Button
                variant="outlined"
                color="error"
                fullWidth
                sx={{ mt: 3, fontWeight: 600 }}
                onClick={handleLogout}
              >
                Logout
              </Button>
              {/* Box Crediti Programmatore */}
              <Box 
                sx={{ 
                  mt: 4,
                  pt: 3,
                  borderTop: '1px solid #e0e0e0',
                  width: '100%',
                  textAlign: 'center',
                  opacity: 0.8
                }}
              >
                <Typography variant="caption" sx={{ display: 'block', mb: 0.5, color: '#666' }}>
                  Sviluppato da
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600, color: '#2a5298' }}>
                  Gelarredi Informatica srl
                </Typography>
                <Typography variant="caption" sx={{ display: 'block', mt: 0.5, color: '#666' }}>
                  © {new Date().getFullYear()} - Tutti i diritti riservati
                </Typography>
                <Typography variant="caption" sx={{ display: 'block', mt: 1, fontSize: '0.7rem', color: '#888' }}>
                  Versione 2.0.1
                </Typography>
              </Box>
            </Paper>
          </div>
        </SwipeableViews>
      </Box>
      <BottomNavigation
        showLabels
        value={page}
        onChange={(_, newValue) => setPage(newValue)}
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          width: '100%',
          maxWidth: 400,
          zIndex: 10,
          borderTop: '1px solid rgba(0, 0, 0, 0.12)'
        }}
      >
        <BottomNavigationAction label="Carta" icon={<LoyaltyIcon />} />
        <BottomNavigationAction label="Acquisti" icon={<ShoppingCartIcon />} />
        <BottomNavigationAction label="Per Te" icon={<LocalOfferIcon />} />
        <BottomNavigationAction label="Profilo" icon={<AccountCircleIcon />} />
      </BottomNavigation>
    </Box>
  );
}